import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  alpha,
  useTheme,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LoginRequiredModal = ({ open, onClose, actionLabel }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const redirect = `${location.pathname}${location.search}`;

  const goLogin = () => {
    onClose?.();
    navigate('/login', { state: { from: redirect } });
  };

  const goRegister = () => {
    onClose?.();
    navigate('/register', { state: { from: redirect } });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
          color: '#fff',
          px: 3,
          pt: 3,
          pb: 2.5,
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8, color: alpha('#fff', 0.9) }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: alpha('#fff', 0.16),
            display: 'grid',
            placeItems: 'center',
            mb: 1.5,
          }}
        >
          <LockOutlinedIcon />
        </Box>
        <DialogTitle sx={{ p: 0, color: 'inherit', fontWeight: 800, fontSize: '1.25rem' }}>
          {t('auth.loginRequired.title')}
        </DialogTitle>
        <Typography sx={{ mt: 0.75, opacity: 0.92, fontSize: '0.92rem' }}>
          {actionLabel
            ? t('auth.loginRequired.actionHint', { action: actionLabel })
            : t('auth.loginRequired.subtitle')}
        </Typography>
      </Box>

      <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('auth.loginRequired.body')}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1, flexDirection: 'column' }}>
        <Button fullWidth variant="contained" onClick={goLogin} sx={{ py: 1.1 }}>
          {t('navigation.login')}
        </Button>
        <Button fullWidth variant="outlined" onClick={goRegister} sx={{ py: 1.1 }}>
          {t('navigation.register')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginRequiredModal;
